import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import type { ErrorResponse } from '@/types/apiTypes';
import type {
  GetImportantDatesResponse,
  UpdateImportantDatePayload,
} from '@/types/clientDetailsApiTypes';
import { IMPORTANT_DATES_BY_CLIENT_QUERY_KEY } from '../useGetImportantDatesByClientQuery';

interface UpdateImportantDateResponse {
  data: GetImportantDatesResponse['data'][number];
}

export interface UpdateImportantDateVariables extends UpdateImportantDatePayload {
  id: number;
  clientId: number;
}

export function useUpdateImportantDateMutation() {
  const queryClient = useQueryClient();
  const { doFetch: updateImportantDate } = useFetch<
    UpdateImportantDatePayload,
    UpdateImportantDateResponse
  >();

  return useMutation<
    UpdateImportantDateResponse,
    ErrorResponse<unknown>,
    UpdateImportantDateVariables
  >({
    mutationFn: ({ id, clientId, ...payload }: UpdateImportantDateVariables) =>
      updateImportantDate(`/api/important-dates/${id}`, {
        method: 'PUT',
        body: payload,
      }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [IMPORTANT_DATES_BY_CLIENT_QUERY_KEY, variables.clientId],
        refetchType: 'all',
      });
    },
  });
}
